import { ArrowLeftOutlined, Button, Col, Row } from 'gokwik-ui-kit'

export const OtherControlsDetails = ({ configInfo, resetCustomiseDetails, handleCustomisation }) => {
    const { config, name } = configInfo
    const categoryMap: Record<
        string,
        {
            description: string
            subcategories: Record<string, any[]>
        }
    > = {}

    if (Array.isArray(config)) {
        config.forEach((subcategoryGroup) => {
            if (subcategoryGroup && typeof subcategoryGroup === 'object') {
                Object.values(subcategoryGroup).forEach((configArray) => {
                    if (Array.isArray(configArray)) {
                        configArray.forEach((cfg) => {
                            const categoryTitle = cfg.categoryTitle
                            const subcategory = cfg.subcategory

                            if (!categoryMap[categoryTitle]) {
                                categoryMap[categoryTitle] = {
                                    description: cfg.categoryDescription || '',
                                    subcategories: {},
                                }
                            }

                            if (!categoryMap[categoryTitle].subcategories[subcategory]) {
                                categoryMap[categoryTitle].subcategories[subcategory] = []
                            }

                            categoryMap[categoryTitle].subcategories[subcategory].push(cfg)
                        })
                    }
                })
            }
        })
    }

    return (
        <Row className='bg-white mt-4 p-4 rounded-md box-border flex'>
            <Col span={24} className='flex gap-4 mb-2'>
                <ArrowLeftOutlined onClick={resetCustomiseDetails} />
                <h4 className='m-0 text-base font-semibold'>{name ?? ''}</h4>
            </Col>

            {Object.entries(categoryMap).map(([categoryTitle, { subcategories, description }]) => (
                <Col span={24} key={categoryTitle} className='flex pt-4'>
                    <div className='header w-[50%]'>
                        <h4 className='m-0 text-sm font-medium'>{categoryTitle}</h4>
                        <p className='pt-1 text-gray-500 text-xs font-normal'>{description}</p>
                    </div>
                    <div className='value w-[50%] flex gap-3 justify-end'>
                        <Button
                            variant='default'
                            className='text-xs'
                            onClick={() =>
                                handleCustomisation({
                                    config: subcategories,
                                    name: categoryTitle,
                                })
                            }
                        >
                            Customise
                        </Button>
                    </div>
                </Col>
            ))}
        </Row>
    )
}
